<template>
  <div class="card mb-4">
    <div class="card-header bg-info text-light">
      Login
    </div>
    <div class="card-body">
      <form v-if="formStatus.success !== true" @submit.prevent="submit" class="needs-validation">
        <fieldset class="form-group">
          <label for="email">Email Address</label>
          <input v-model="credential.email" type="text" :class="['form-control', { 'is-invalid':validationErrors.userid }]" id="email" name="email">
          <div class="invalid-feedback" v-if="validationErrors.email" v-text="validationErrors.email"></div>
        </fieldset>
        <fieldset class="form-group">
          <label for="password">Password</label>
          <input v-model="credential.password" type="password" :class="['form-control', { 'is-invalid':validationErrors.password }]" id="password" name="password">
          <div class="invalid-feedback" v-if="validationErrors.password" v-text="validationErrors.password"></div>
        </fieldset>
        <fieldset v-if="showFormSelectorg" class="form-group">
          <label for="selectorg">Organization</label>
          <select v-model="credential.orgid" :class="['form-control', { 'is-invalid':validationErrors.selectorg }]" id="selectorg" name="selectorg">
            <option v-for="org in selectorg" :key="org.id" :value="org.id">
              {{org.name}}
            </option>
          </select>
          <div class="invalid-feedback" v-if="validationErrors.selectorg" v-text="validationErrors.selectorg"></div>
        </fieldset>
        <button v-if="!showFormStatusMessage" type="submit" class="btn btn-primary col-sm-3">Login</button>
        <div v-if="!showFormStatusMessage" class="float-right mt-1">
          <router-link to="/reset">Reset Password</router-link>
        </div>
      </form>
      <div v-if="showFormStatusMessage" :class="['alert', { 'alert-success':formStatus.success, 'alert-danger':formStatus.error }, 'alert-dismissible']" role="alert" style="margin-top:20px">
        <h4 class="alert-heading" v-html="formStatus.statusHeading"></h4>
        <p v-html="formStatus.statusBody"></p>
        <button @click="clearFormStatus()" type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import LoginCredential from '@/structs/LoginCredential'

export default {
  name: 'LoginForm',
  data () {
    return {
      credential: new LoginCredential(),
      selectorg: [],
      validationErrors: {
        email: null,
        password: null,
        selectorg: null
      },
      formStatus: {
        success: null,
        error: null,
        statusHeading: null,
        statusBody: null
      }
    }
  },
  computed: {
    showFormStatusMessage () {
      return this.formStatus.success || this.formStatus.error
    },
    showFormSelectorg () {
      return !!this.selectorg.length > 0
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    submit () {
      if (this.validateForm()) {
        this.login(this.credential)
          .then(response => {
            if (response.data && response.data.selectorg && response.data.selectorg.length > 0) {
              this.selectorg = response.data.selectorg
            }
          })
          .catch(response => { this.markError(response.message) })
      }
    },
    clearFormStatus () {
      this.formStatus.success = null
      this.formStatus.error = null
      this.statusHeading = null
      this.statusBody = null
    },
    markSuccess () {
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Success!'
      this.formStatus.statusBody = 'You will now be logged in.'
      this.formStatus.success = true
    },
    markError (message) {
      console.log(message)
      this.clearFormStatus()

      this.formStatus.statusHeading = 'Error'
      this.formStatus.statusBody = (message || 'Unable to login.')
      this.formStatus.error = true
    },
    clearValidationErrors () {
      this.validationErrors.userid = null
      this.validationErrors.password = null
    },
    validateForm () {
      this.clearValidationErrors()
      if ((this.credential.email || '') === '') {
        this.validationErrors.email = 'Empty or invalid email'
        return false
      }

      if ((this.credential.password || '') === '') {
        this.validationErrors.password = 'Empty or invalid password'
        return false
      }

      return true
    }
  }
}

</script>
